export default {
    mounted(el, binding) {
        el.classList.add('advanced-feature');

        // Zugriff auf den Komponenten-Kontext (Vue 3 Syntax)
        const instance = binding.instance;

        if (!instance?.$userData?.rights?.accessAdvancedFeatures) {
            el.style.display = 'none';
            el.style.pointerEvents = 'none';
            el.disabled = true;
        }
    }
}